export default __webpack_public_path__ + "static/media/oaktree.cc3c1f59.PNG";